<template>
  <div class="insights-list">
    <form class="insights-filters" role="search" aria-label="Filtrar Insights" @submit.prevent>
      <label for="insights-segment"
        >Segmento
        <select id="insights-segment" v-model="segment">
          <option value="">Todos os segmentos</option>
          <option v-for="option in segments" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </label>
      <label for="insights-query"
        >Nome ou palavra-chave
        <input
          id="insights-query"
          v-model="query"
          type="search"
          placeholder="Digite para buscar"
          autocomplete="off"
        />
      </label>
      <button type="button" class="btn btn-outline" :disabled="!segment && !query" @click="clear">
        Limpar filtros
      </button>
    </form>
    <p class="insights-result-count" role="status" aria-live="polite" aria-atomic="true">
      {{ filtered.length }}
      {{ filtered.length === 1 ? 'publicação encontrada' : 'publicações encontradas' }}
    </p>
    <ApprovedList v-if="filtered.length" :items="filtered" :screen="screen" kind="news" />
    <p v-else class="insights-empty">
      Nenhuma publicação encontrada. Tente outro segmento ou palavra-chave.
    </p>
  </div>
</template>
<script>
import ApprovedList from './ApprovedList.vue';
import { contentValue, plainText } from '@/services/contentApi';
const normalize = (value) =>
  plainText(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR')
    .trim();
export default {
  name: 'InsightsList',
  components: { ApprovedList },
  props: { items: { type: Array, default: () => [] }, screen: Object },
  data: () => ({ segment: '', query: '' }),
  computed: {
    indexed() {
      return this.items.map((item) => ({
        item,
        segment: normalize(contentValue(item, 'iti_campoextra1')),
        label: plainText(contentValue(item, 'iti_campoextra1')),
        text: normalize(
          ['iti_nome', 'iti_referencia', 'iti_campoextra1', 'iti_resumo1', 'iti_descricao1']
            .map((field) => contentValue(item, field))
            .join(' '),
        ),
      }));
    },
    segments() {
      const options = new Map();
      this.indexed.forEach((entry) => {
        if (entry.segment && !options.has(entry.segment))
          options.set(entry.segment, { value: entry.segment, label: entry.label });
      });
      return [...options.values()].sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
    },
    filtered() {
      const words = normalize(this.query).split(/\s+/).filter(Boolean);
      return this.indexed
        .filter(
          (entry) =>
            (!this.segment || entry.segment === this.segment) &&
            words.every((word) => entry.text.includes(word)),
        )
        .map((entry) => entry.item);
    },
  },
  methods: {
    clear() {
      this.segment = '';
      this.query = '';
    },
  },
};
</script>
